import { Form, FormActions, FormLayout } from 'ui';
import {
  VideoBasicInfoFormContent,
  type VideoBasicInfoFormValues,
  VideoChannelsFormContent,
  type VideoChannelsFormValues,
} from '../../../components';

export type VideoCreateFormValues = VideoBasicInfoFormValues & VideoChannelsFormValues;

type P = {
  isLoading: boolean;
  onSuccess: (values: VideoCreateFormValues) => void;
};

const VideoCreateForm = ({ isLoading, onSuccess }: P) => {
  const [form] = Form.useForm<VideoCreateFormValues>();

  const onFinish = (values: VideoCreateFormValues) => {
    onSuccess(values);
  };

  return (
    <Form<VideoCreateFormValues> form={form} onFinish={onFinish}>
      <FormLayout>
        <VideoBasicInfoFormContent mode="create" />
        <VideoChannelsFormContent<VideoCreateFormValues> />
        <FormActions submit={{ children: 'Save', loading: isLoading }} />
      </FormLayout>
    </Form>
  );
};

export default VideoCreateForm;
